import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default class extends Controller {
  static targets = ["image", "text"]

  connect() {
    if (!this.hasImageTarget) return

    gsap.to(this.imageTarget, {
      yPercent: 20,
      ease: "none",
      scrollTrigger: {
        trigger: this.element,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    })

    if (this.hasTextTarget) {
      gsap.to(this.textTarget, {
        yPercent: -10,
        ease: "none",
        scrollTrigger: {
          trigger: this.element,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      })
    }
  }
}
